import "./index.css";
import App from "./App";

import React from "react";
import ReactDOM from "react-dom";

import reportWebVitals from "./reportWebVitals";

import { ApolloProvider } from "@apollo/client";
import Amplify from "aws-amplify";

import awsExports from "./aws-exports-env";

import { client } from "./apollo";

import './i18n';

Amplify.configure(awsExports);

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
